'use strict';

import UserAlreadyLinkedError from 'ck-core/source/errors/UserAlreadyLinkedError';
import UserLinkPendingError from 'ck-core/source/errors/UserLinkPendingError';
import UserNotFoundError from 'ck-core/source/errors/UserNotFoundError';
import UserHasFamilyError from 'ck-core/source/errors/UserHasFamilyError';
import UserHasActiveSubscriptionError from 'ck-core/source/errors/UserHasActiveSubscriptionError';
import React from 'react';
import PropTypes from 'prop-types';
import UserCard from './UserCard';
import Form from 'ck-core-client/source/ui/Form.jsx';
import RoundButton from 'ck-core-client/source/ui/RoundButton';
import TextInput from 'ck-core-client/source/ui/form/TextInput';

export default class AddUserCard extends React.Component {
	async validateName(value) {
		try {
			// 'Fake' call the endpoint in order to generate the detailed errors
			await CK.clientSockets.users.emit(
				'linkSubUser',
				{
					name: value
				},
				{
					waitForVerify: false
				}
			);

			return {
				valid: false,
				error: 'Unknown error'
			};
		} catch (err) {
			switch (err.name) {
				case UserHasFamilyError.errorClassName:
				case UserHasActiveSubscriptionError.errorClassName:
				case UserLinkPendingError.errorClassName:
				case UserAlreadyLinkedError.errorClassName:
					// Exists and cannot be linked
					return {
						valid: false,
						error: err.message
					};

				case UserNotFoundError.errorClassName:
					// Doesn't exist
					return {
						valid: false,
						error: err.message
					};

				default:
					// Exists and unlinked
					return {
						valid: true,
						error: err.message
					};
			}
		}
	}

	render() {
		return (
			<div className="UserCard">
				<div className="username">Invite User</div>

				<Form handleSubmit={this.props.handleLink} buttonSize="tiny" buttonText="Invite">
					<TextInput name="name" label="Username" validate={this.validateName} />
				</Form>
				<RoundButton
					size="tiny"
					buttonClass="cancel"
					text="Cancel"
					handleClick={this.props.handleCancel}
				/>
			</div>
		);
	}
}

AddUserCard.propTypes = {
	handleLink: PropTypes.func.isRequired,
	handleCancel: PropTypes.func.isRequired
};
